import apiClient from "../client";

// GET /api/dossier — dossier HTML proxied from SharePoint
export const getDossierHtml = async () => {
  const response = await apiClient.get("/dossier", { responseType: "text" });
  return response.data;
};
